import type { PreInitiateResponse } from '../domain/models';
import { parseHostDiscountSummary, type HostDiscountSummary } from './discountSummary';

export type InstallmentPromoScenarioSnapshot = {
  totals: PreInitiateResponse['totals'];
  discountSummary: HostDiscountSummary | undefined;
};

export type ParsedInstallmentPromoPreview = {
  one: InstallmentPromoScenarioSnapshot;
  multi: InstallmentPromoScenarioSnapshot;
};

const parseScenario = (raw: unknown): InstallmentPromoScenarioSnapshot | undefined => {
  if (!raw || typeof raw !== 'object') return undefined;
  const row = raw as Record<string, unknown>;
  const totals = row.totals as PreInitiateResponse['totals'];
  const discountSummary = parseHostDiscountSummary(row.discountSummary);
  if (!totals && !discountSummary) return undefined;
  return { totals, discountSummary };
};

/** `installmentPromoPreview` del pre-initiate (escenarios 1 cuota vs multi). */
export const parseInstallmentPromoPreview = (raw: unknown): ParsedInstallmentPromoPreview | undefined => {
  if (!raw || typeof raw !== 'object') return undefined;
  const root = raw as Record<string, unknown>;
  const one = parseScenario(root.oneInstallment);
  const multi = parseScenario(root.multiInstallment);
  if (!one || !multi) return undefined;
  return { one, multi };
};

export const installmentPromoScenarioForMonths = (
  preview: ParsedInstallmentPromoPreview,
  months: number,
): InstallmentPromoScenarioSnapshot => (months === 1 ? preview.one : preview.multi);
